export function Dashboard() {
  return (
    <>
      Bem vindo, adm.
    </>
  )
}